export default __webpack_public_path__ + "static/media/walletIcon.196a6d4b.svg";